import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { ConfigProvider } from "../../../config-provider.service";
import { UsersProvider } from '../../providers/users-provider';
import { CurrentUser } from "../../../common/providers/current-user";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatError, MatFormField } from "@angular/material/form-field";
import { NgIf } from "@angular/common";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { MatProgressBar } from "@angular/material/progress-bar";
import { User } from "../../../common/models/user";
import { Observable } from "rxjs";

@Component({
  selector: 'users-change-password-dialog',
  providers: [],
  styleUrls: ['./change-password-dialog.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatFormField,
    NgIf,
    MatDialogModule,
    MatInput,
    ReactiveFormsModule,
    MatButton,
    MatProgressBar,
    MatError,
  ],
  templateUrl: './change-password-dialog.html'
})
export class UsersChangePasswordDialogComponent implements AfterViewInit {
    public PASSWORD_MIN_LENGTH = 6;
    public isLoading = false;
    public passwordWrongError = false;
    private checkPasswordWrong: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
      return this.passwordWrongError ? { wrong: { valid: false } } : null;
    };
     private checkPasswordsMatch: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
      // Assuming 'this' is correctly referring to the component class
      return this.newPassword1FormControl?.value !== this.newPassword2FormControl?.value ? { notMatched: true } : null;
    };
    public currentPasswordFormControl: FormControl = new FormControl('', [
        Validators.required,
        this.checkPasswordWrong
    ]);
    public newPassword1FormControl: FormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(this.PASSWORD_MIN_LENGTH)
    ]);
    public newPassword2FormControl: FormControl = new FormControl('', [
        Validators.required,
        this.checkPasswordsMatch
    ]);



    public user: User = {} as User;
    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        public dialog: MatDialogRef<UsersChangePasswordDialogComponent>,
        public utils: UtilsProvider,
        private _translater: TranslateService,
        private _toaster: MatSnackBar,
        private _users: UsersProvider,
        private _changeDetector: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.user = _data.user;
    }

    public ngAfterViewInit() {

    }

    public onSaveClicked(): void {
        this.isLoading = true;
        this.save().subscribe({
            next: (result) => {
                this._toaster.open(this._translater.instant('Password_updated'), '', { duration: 5000 });
                this.isLoading = false;
                this.dialog.close(result);
            },
            error: (error) => this.onError(error)
        });
    }

    public onCurrentPasswordChange(): void {
        this.passwordWrongError = false;
    }

    public onPassword1Change(): void {
        if (!this.newPassword2FormControl.pristine) {
            this.newPassword2FormControl.updateValueAndValidity();
        }
    }

    private save(): Observable<any> {
        return this._users.changePassword(this.user, this.newPassword1FormControl.value, this.currentPasswordFormControl.value);
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 401) {
            this.passwordWrongError = true;
            this.currentPasswordFormControl.updateValueAndValidity();
            return;
        }

        this._toaster.open(this._translater.instant('Error_unknown'), '', { duration: 5000 });
    }

    private checkPasswords(): any {
        if (!this.newPassword1FormControl
            || !this.newPassword2FormControl
            || this.newPassword1FormControl.value === this.newPassword2FormControl.value) {
            return null;
        }

        return { match: { valid: false } };
    }
}
